import React from "react";
import HubspotForm from "react-hubspot-form";
import { toast } from "react-toastify";
import { Row, Col } from "reactstrap";

class ContactSection extends React.Component {
  render() {
    const handleSubmit = () => {
      toast.success("Formulario enviado correctamente");
      setTimeout(function () {
        window.location.reload(1);
      }, 2000);
    };

    return (
      <React.Fragment>
        <section className="section bg-light" id="pqr">
          <div className="container">
            <div className="row">
              <Col lg="12">
                <div className="title-heading mb-5">
                  <h3 className="text-dark mb-1 font-weight-light text-uppercase">
                    PQR
                  </h3>
                  <div className="title-border-simple position-relative" />
                </div>
              </Col>
            </div>

            <Row>
              <Col lg="12">
                <div className="contact-box p-5">
                  <Row>
                    <Col lg="12" md="12">
                      <HubspotForm
                        portalId="21377285"
                        formId="b6274b65-9208-4e8e-b2cb-38e4e125334e"
                        onSubmit={handleSubmit}
                        loading={<h1>Loading...</h1>}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </section>

        <section className="section bg-light" id="contact">
          <div className="container">
            <div className="row">
              <Col lg="12">
                <div className="title-heading mb-5">
                  <h3 className="text-dark mb-1 font-weight-light text-uppercase">
                    Contacto
                  </h3>
                  <div className="title-border-simple position-relative" />
                </div>
              </Col>
            </div>

            <Row>
              <Col lg="12">
                <div className="contact-box p-5">
                  <Row>
                    <Col lg="12" md="12">
                      <HubspotForm
                        portalId="21377285"
                        formId="13f3c55b-0743-47d6-835a-e0385c3c5043"
                        onSubmit={handleSubmit}
                        loading={<h1>Loading...</h1>}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default ContactSection;
